// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QBviI9WV2pQhOqbNQqUIw","table":"_3lciLsaZMnAYs4t4oQNx0X"};